/* Fiboli menu: the "Clean list" that opens under a button instead of the browser's grey dropdown.
   - FiboliMenu.open(button, { label, options: [{ value, label, tag, apart, disabled }], value, onPick, matchWidth })
     opens a list under (or above) the button; the cart popup uses it for "How often?".
   - Any <select data-fiboli-menu> is upgraded: a button shows the choice, the select stays in the form underneath
     (same name, same value, same validation) and gets input + change events when a row is picked.
   Keyboard: arrows, Home/End, letters, Enter/Space, Escape, Tab. Theme settings > Dropdown menus sets the colours. */
(function () {
  'use strict';
  if (window.FiboliMenu) return;
  var CK = '<svg class="fm-ck" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M3 8.5l3.2 3.2L13 4.8" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CARET = '<svg class="fm-caret" viewBox="0 0 10 7" aria-hidden="true" focusable="false"><path d="M1 1.5l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
  var top = typeof HTMLElement !== 'undefined' && 'popover' in HTMLElement.prototype;
  var uid = 0, cur = null, typed = '', typedAt = 0;
  var esc = function (s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); };

  function rows(list) { return Array.prototype.slice.call(list.querySelectorAll('.fm-opt')); }
  function usable(o) { return o.getAttribute('aria-disabled') !== 'true'; }
  function setActive(o) {
    if (!cur || !o) return;
    rows(cur.list).forEach(function (r) { r.classList.toggle('is-act', r === o); });
    cur.list.setAttribute('aria-activedescendant', o.id);
    var lr = cur.list.getBoundingClientRect(), r = o.getBoundingClientRect();
    if (r.top < lr.top) cur.list.scrollTop -= lr.top - r.top + 4; else if (r.bottom > lr.bottom) cur.list.scrollTop += r.bottom - lr.bottom + 4;
  }
  function move(d) {
    var all = rows(cur.list).filter(usable); if (!all.length) return;
    var at = all.indexOf(cur.list.querySelector('.fm-opt.is-act'));
    setActive(all[d === 'first' ? 0 : d === 'last' ? all.length - 1 : Math.max(0, Math.min(all.length - 1, (at < 0 ? -1 : at) + d))]);
  }
  /* under the button, or above it when there is more room there; never past the screen edges */
  function place() {
    if (!cur) return;
    var b = cur.anchor.getBoundingClientRect(), L = cur.list, vw = document.documentElement.clientWidth, vh = window.innerHeight;
    if (!cur.anchor.isConnected || b.bottom < 0 || b.top > vh || (!b.width && !b.height)) { close(false); return; }
    L.style.maxHeight = ''; L.style.width = cur.matchWidth ? b.width + 'px' : '';
    var h = L.offsetHeight, w = L.offsetWidth, below = vh - b.bottom - 12, above = b.top - 12;
    var up = h > below && above > below, room = Math.max(120, up ? above : below);
    if (h > room) { L.style.maxHeight = room + 'px'; h = room; }
    var y = up ? b.top - 6 - h : b.bottom + 6, x = Math.max(8, Math.min(b.left, vw - w - 8));
    L.style.left = x + 'px'; L.style.top = y + 'px';
    /* a transformed parent (drawer sliding in) moves fixed boxes with it: correct by what actually happened */
    var got = L.getBoundingClientRect();
    if (Math.abs(got.left - x) > 1 || Math.abs(got.top - y) > 1) { L.style.left = (2 * x - got.left) + 'px'; L.style.top = (2 * y - got.top) + 'px'; }
    L.classList.toggle('is-up', up);
  }
  function close(focusBack) {
    if (!cur) return;
    var c = cur; cur = null;
    c.anchor.setAttribute('aria-expanded', 'false');
    document.removeEventListener('pointerdown', onOutside, true);
    window.removeEventListener('resize', onMove); window.removeEventListener('scroll', onMove, true);
    try { if (top && c.list.matches(':popover-open')) c.list.hidePopover(); } catch (e) {}
    if (c.list.parentNode) c.list.parentNode.removeChild(c.list);
    if (focusBack && c.anchor.isConnected) c.anchor.focus({ preventScroll: true });
    if (c.onClose) c.onClose();
  }
  function pick(o) {
    if (!cur || !o || !usable(o)) return;
    var c = cur, v = o.getAttribute('data-value');
    close(true);
    if (v !== c.value && c.onPick) c.onPick(v, c.anchor);
  }
  var moveRaf = 0;
  function onMove(e) {
    if (!cur) return;
    var t = e && e.type === 'scroll' ? e.target : null;
    if (t && t.nodeType === 1) {
      if (cur.list.contains(t)) return;
      /* a scrolling box (the cart list) moved the button out of its own view: the menu goes too */
      if (t.contains(cur.anchor)) { var a = cur.anchor.getBoundingClientRect(), r = t.getBoundingClientRect(); if (a.bottom <= r.top || a.top >= r.bottom) { close(false); return; } }
    }
    if (moveRaf) return; moveRaf = requestAnimationFrame(function () { moveRaf = 0; place(); });
  }
  /* only a real press outside closes the list: scripts that press buttons (closing a Klaviyo pop-up) must not */
  function onOutside(e) { if (cur && e.isTrusted && !cur.list.contains(e.target) && !cur.anchor.contains(e.target)) close(false); }
  function onKey(e) {
    if (!cur) return;
    var k = e.key, done = true;
    if (k === 'ArrowDown') move(1); else if (k === 'ArrowUp') move(-1);
    else if (k === 'Home' || k === 'PageUp') move('first'); else if (k === 'End' || k === 'PageDown') move('last');
    else if (k === 'Enter' || k === ' ') pick(cur.list.querySelector('.fm-opt.is-act'));
    else if (k === 'Escape' || k === 'Tab') close(true);
    else if (k.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey) {
      var now = Date.now(); typed = (now - typedAt < 600 ? typed : '') + k.toLowerCase(); typedAt = now;
      var all = rows(cur.list).filter(usable), at = all.indexOf(cur.list.querySelector('.fm-opt.is-act'));
      var order = all.slice(at + (typed.length > 1 ? 0 : 1)).concat(all.slice(0, at + (typed.length > 1 ? 0 : 1)));
      for (var i = 0; i < order.length; i++) if (order[i].textContent.trim().toLowerCase().indexOf(typed) === 0) { setActive(order[i]); break; }
    } else done = false;
    if (done) { e.preventDefault(); e.stopPropagation(); }
  }

  function open(anchor, o) {
    if (cur && cur.anchor === anchor) { close(true); return; }
    close(false);
    var id = 'fm-' + (++uid), L = document.createElement('div');
    L.className = 'fm-list' + (o.className ? ' ' + o.className : ''); L.id = id;
    L.setAttribute('role', 'listbox'); L.setAttribute('tabindex', '-1'); L.setAttribute('aria-label', o.label || '');
    if (top) L.setAttribute('popover', 'manual');
    var value = o.value == null ? '' : String(o.value);
    L.innerHTML = (o.options || []).map(function (op, i) {
      var sel = String(op.value) === value;
      return '<div class="fm-opt' + (op.apart ? ' fm-opt--apart' : '') + '" role="option" id="' + id + '-' + i + '" data-value="' + esc(op.value) + '" aria-selected="' + sel + '"' + (op.disabled ? ' aria-disabled="true"' : '') + '>' +
        '<span class="fm-lab">' + esc(op.label) + '</span>' + (op.tag ? '<span class="fm-tag">' + esc(op.tag) + '</span>' : '') + CK + '</div>';
    }).join('');
    /* the list lives next to the button (inside any dialog or drawer, so their focus rules keep working) and is
       lifted to the top layer where the browser can, so no scrolling box can cut it off */
    (o.host || anchor.parentNode).appendChild(L);
    cur = { anchor: anchor, list: L, value: value, onPick: o.onPick, onClose: o.onClose, matchWidth: !!o.matchWidth };
    try { if (top) L.showPopover(); } catch (e) {}
    anchor.setAttribute('aria-expanded', 'true'); anchor.setAttribute('aria-controls', id);
    place();
    L.addEventListener('keydown', onKey);
    L.addEventListener('click', function (e) { var r = e.target.closest('.fm-opt'); if (r) pick(r); });
    L.addEventListener('pointermove', function (e) { var r = e.target.closest('.fm-opt'); if (r && usable(r) && !r.classList.contains('is-act')) setActive(r); });
    document.addEventListener('pointerdown', onOutside, true);
    window.addEventListener('resize', onMove); window.addEventListener('scroll', onMove, true);
    setActive(L.querySelector('.fm-opt[aria-selected="true"]') || rows(L).filter(usable)[0]);
    L.focus({ preventScroll: true });
  }

  /* ---------- <select data-fiboli-menu> ---------- */
  function text(sel) { var o = sel.options[sel.selectedIndex]; return o ? o.text.trim() : ''; }
  function sync(sel) {
    var b = sel._fm; if (!b) return;
    var o = sel.options[sel.selectedIndex];
    b.querySelector('.fm-field__v').textContent = text(sel);
    b.classList.toggle('is-placeholder', !!o && o.value === '');
    b.disabled = sel.disabled;
    if (sel.value !== '' || !sel.required) { b.removeAttribute('aria-invalid'); var m = b.parentNode.querySelector('.fm-err'); if (m) m.hidden = true; }
  }
  function enhance(sel) {
    if (sel._fm || sel.multiple || sel.size > 1) return;
    var wrap = document.createElement('span'); wrap.className = 'fm-wrap';
    var b = document.createElement('button'); b.type = 'button'; b.className = 'fm-field ' + (sel.getAttribute('data-fiboli-menu') || '');
    b.setAttribute('aria-haspopup', 'listbox'); b.setAttribute('aria-expanded', 'false');
    var vid = 'fm-v-' + (++uid);
    b.innerHTML = '<span class="fm-field__v" id="' + vid + '"></span>' + CARET;
    var lab = sel.id && document.querySelector('label[for="' + sel.id + '"]');
    if (lab) { if (!lab.id) lab.id = 'fm-l-' + uid; b.setAttribute('aria-labelledby', lab.id + ' ' + vid); }
    else b.setAttribute('aria-label', sel.getAttribute('aria-label') || sel.name || '');
    sel.parentNode.insertBefore(wrap, sel); wrap.appendChild(b); wrap.appendChild(sel);
    sel.classList.add('fm-native'); sel.tabIndex = -1; sel.setAttribute('aria-hidden', 'true');
    sel._fm = b; sync(sel);
    b.addEventListener('click', function () {
      var opts = Array.prototype.filter.call(sel.options, function (op) { return !(op.value === '' && (sel.required || op.disabled)) && !op.hidden; });
      open(b, {
        label: lab ? lab.textContent.replace(/\*/g, '').trim() : (sel.getAttribute('aria-label') || ''), matchWidth: true, value: sel.value,
        options: opts.map(function (op) { return { value: op.value, label: op.text.trim(), disabled: op.disabled }; }),
        onPick: function (v) { sel.value = v; sync(sel); sel.dispatchEvent(new Event('input', { bubbles: true })); sel.dispatchEvent(new Event('change', { bubbles: true })); }
      });
    });
    /* the label points at the select: send its focus to the button */
    sel.addEventListener('focus', function () { b.focus(); });
    sel.addEventListener('change', function () { sync(sel); });
    /* required and empty: the browser's own bubble would point at the hidden select, so show the message here */
    sel.addEventListener('invalid', function (e) {
      e.preventDefault(); b.setAttribute('aria-invalid', 'true');
      var m = wrap.querySelector('.fm-err');
      if (!m) { m = document.createElement('span'); m.className = 'fm-err'; m.id = 'fm-e-' + (++uid); m.setAttribute('role', 'alert'); wrap.appendChild(m); b.setAttribute('aria-describedby', m.id); }
      m.textContent = sel.validationMessage; m.hidden = false;
      if (sel.form && sel.form.querySelector(':invalid') === sel) b.focus();
    });
    if (window.MutationObserver) new MutationObserver(function () { sync(sel); }).observe(sel, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
    if (sel.form) sel.form.addEventListener('reset', function () { setTimeout(function () { sync(sel); }); });
  }
  function scan(root) { (root || document).querySelectorAll('select[data-fiboli-menu]').forEach(enhance); }
  /* any button that opens a list (cart "How often?", upgraded selects): arrow up or down opens it, like a menu button */
  document.addEventListener('keydown', function (e) {
    var b = e.target;
    if ((e.key !== 'ArrowDown' && e.key !== 'ArrowUp') || cur || !b || b.tagName !== 'BUTTON' || b.getAttribute('aria-haspopup') !== 'listbox' || b.disabled) return;
    e.preventDefault(); b.click();
  });

  /* tags: Theme settings > Dropdown menus > "Show the saving on each subscription row" */
  var me = document.currentScript;
  window.FiboliMenu = {
    open: open, close: close, enhance: enhance, scan: scan, isOpen: function () { return !!cur; },
    /* a part of the page is redrawn while the list is open: anchorIn tells whether its button is in there, and
       rebind moves the list to the redrawn button (or closes it when there is none) */
    anchorIn: function (root) { return cur && root && root.contains(cur.anchor) ? cur.anchor : null; },
    rebind: function (b) {
      if (!cur) return;
      if (!b) { close(false); return; }
      cur.anchor = b; b.setAttribute('aria-expanded', 'true'); b.setAttribute('aria-controls', cur.list.id); place();
    },
    tags: !me || me.getAttribute('data-menu-tags') !== 'false'
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); }); else scan();
  /* theme editor and section reloads */
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
